// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';

import { confirmEmailVerification } from '../../api/selfServiceServices';
import type { VerificationOtpRequest, VerificationOtpResponse } from '../../api/types';

export type ConfirmEmailVerification = {
  codingCtxHeader: string;
  confirmRequest: VerificationOtpRequest;
};

const useConfirmEmailOtp = () => {
  return useMutation<VerificationOtpResponse, Error, ConfirmEmailVerification>({
    mutationFn: (data: ConfirmEmailVerification) =>
      confirmEmailVerification(data.confirmRequest, data.codingCtxHeader),
  });
};

export default useConfirmEmailOtp;
